import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';
import { useHistory, useLocation } from 'react-router-dom';

import { TagScrolling, TagScrollingWithControls } from '../../components/TagScrolling';
import { selectTags } from '../../selectors/tags/selectTags';
import * as s from './TagScrollingContainer.css';

/** Скроллинг тэгов для мобилки и десктопа */
export const TagScrollingContainer = () => {
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const [activeTagId, setActiveTagId] = useState(0);
  const deviceType = useDeviceType();
  const isDesktop = () => deviceType === 'desktop';
  const tags = useSelector(selectTags);
  const history = useHistory();

  /** Устанавливает активный тэг */
  useEffect(() => {
    const qsWithTag = searchParams.get('with-tag');
    const activeTag = tags.find(tag => tag.name === qsWithTag);

    setActiveTagId(activeTag?.id || 0);
  }, [searchParams, tags]);

  /** Отправляет на страницу поиска по тэгам */
  const handleClick = useCallback(
    (tagName: string) => {
      searchParams.set('with-tag', tagName);
      searchParams.delete('page');
      history.push(`/magazine/?${searchParams.toString()}`);
    },
    [history, searchParams],
  );

  if (!tags.length) {
    return null;
  }

  return (
    <div className={`${s['wrapper']}`}>
      {isDesktop() ? (
        <TagScrollingWithControls items={tags} size={'XS'} onClick={handleClick} activeTagId={activeTagId} />
      ) : (
        <TagScrolling items={tags} size={'M'} onClick={handleClick} activeTagId={activeTagId} />
      )}
    </div>
  );
};
